import { render } from "./essay-exam.vue?vue&type=template&id=42dcd7ca&scoped=true"
import script from "./essay-exam.vue?vue&type=script&lang=js"
export * from "./essay-exam.vue?vue&type=script&lang=js"

import "./essay-exam.vue?vue&type=style&index=0&id=42dcd7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dcd7ca"]])

export default __exports__